import {createAllActions} from 'web-app/util/redux/typed-action-helpers';

const domain = 'MODALS/PASSWORD_MODAL';

export const {
    action: askForPassword,
    success: askForPasswordSuccess,
    failed: askForPasswordFailed,
} = createAllActions(
    `${domain}/ASK_FOR_PASSWORD`,
    (message?: string) => ({message}),
    (password: string) => ({password}),
    () => ({}),
);
